import { notificationApiQuery } from '../';

export const notificationApi = notificationApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getWSToken: builder.query({
        query: () => {
          return {
            method: 'get',
            url: '/authentication/token',
          };
        },
      }),

      markAllRead: builder.mutation({
        query: () => {
          return {
            method: 'put',
            url: '/notification/read_all',
          };
        },
        invalidatesTags: ['GetNotifications'],
      }),

      markAsRead: builder.mutation({
        query: ({ id }) => {
          return {
            method: 'post',
            url: '/notification/read',
            params: {
              id,
            },
          };
        },
      }),

      getNotifications: builder.query({
        query: ({ filter }) => {
          const defaultParams = { recipient: 'in-app', archived: false };
          const { notification_type, unread } = filter || {};
          const params = { ...defaultParams, per_page: 50 };
          params.notification_type =
            notification_type === 'all' ? null : notification_type;
          // Dont send the read key if we wish to see both read and unread notifications .
          if (unread === true) {
            params.read = false;
          }
          return {
            method: 'get',
            url: '/notification/index',
            params,
          };
        },
        providesTags: ['GetNotifications'],
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetWSTokenQuery,
  useGetNotificationsQuery,
  useMarkAllReadMutation,
  useMarkAsReadMutation,
} = notificationApi;
